<div class="col-2 custom-button">
  @if (column.includes('Enabled')) {
    <div class="signifyBookmd rSet">Enable feature<input type="checkbox"
      [checked]="mtpEnabledval" [(ngModel)]="ngModelval['Enabled']" name="mtpEnabled" class="primary-checkbox"
      id="mtpEnabled" (change)="isFeatureEnabled($event.target.checked)" />
      <!-- added id here -->
      <label class="enable-feature" for="mtpEnabled" aria-label="Enable feature"><span id="MTP-enable-feature-checkbox" class="extra-border-enablefeat"></span></label>
    </div>
  }
</div>
<div class="col-3 custom-button-led">
  <div class="signifyBookmd" [ngClass]="isEnabled ? 'disable-graph' : 'enable-graph'">Philips LED light engines<input
    type="checkbox" [checked]="mtpPhilipsLedLightEnginesSelected"
    [(ngModel)]="ngModelval['PhilipsLedLightEnginesSelected']" name="MtpPhilipsLedLightEnginesSelected"
    class="primary-checkbox" id="MtpPhilipsLedLightEnginesSelected"
    [ngClass]="{'disbaleStyle-2': isEnabled, 'inputCssStandard': quickConfigvalue===true}"
    (change)="isPhilipsLedLightEnginesSelected($event.target.checked)" [disabled]="isEnabled" />
    <!-- added id here -->
    <label class="enable-feature" for="MtpPhilipsLedLightEnginesSelected" aria-label="Philips LED light engines"><span
    id="MtpPhilipsLedLightEnginesCheckBox" class="extra-border-enablefeat"></span></label>
  </div>
</div>
@if (!quickConfigvalue) {
  <div class="row" [ngClass]="isEnabled ? 'disable-graph' : 'enable-graph'">
    <app-mtp-graph class="col-10"></app-mtp-graph>
  </div>
}

@if (!PhilipsLedLightEnginesSelected) {
  <div id="corridor_DelayTime_container" class="row slider-container ml-left align-center">
    <div class="col-1 signifyBookmd interface-text">NTC present</div>
    <div class="col-2">
      <!-- added id here -->
      <select
        id="Mtp-NtcPresent-dropdown"
        [ngClass]="{'showingError': inputError['SelectedNtc']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
        [(ngModel)]="ngModelval['SelectedNtc']" class="signifyBookmd select-dimming"
        (change)="onChangeList($event.target.value)" [disabled]="isEnabled">
        @for (item of selectedInterface; track item) {
          <option [value]="item" class="info-val">
            {{ item }}
          </option>
        }
      </select>
    </div>
    <div class="col-8 input-section">
      <div class="section col-4">
        @if (isCustomSelected) {
          <div class=" signifyBookmd interface-text ">R (25 &deg;C)</div>
        }
        @if (isCustomSelected) {
          <div class="d-flex align-items-center pd-0">
            <input type="number" [(value)]="ngModelval['NtcResistance']"
              (input)="textValChanged($event.target.value, 'NtcResistance')" id="mtp_NtcResistance_txtbox"
              (keypress)="numberOnly($event)"
              [ngClass]="{'showingError': inputError['NtcResistance']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
              class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} section-input"
              [disabled]="isEnabled" />
              <p class="signifyBookmd section-input-unit mb-0 ml-2">&Omega;</p>
            </div>
          }
        </div>
        <div class="section col-4 section-two">
          @if (isCustomSelected) {
            <div class="signifyBookmd interface-text">&beta; (25 &deg;C/T)
            </div>
          }
          @if (isCustomSelected) {
            <div class="d-flex align-items-center pd-0">
              <input type="number" [(value)]="ngModelval['NtcBeta']"
                (input)="textValChanged($event.target.value, 'NtcBeta')" id="mtp_NtcBeta_txtbox"
                (keypress)="numberOnly($event)"
                [ngClass]="{'showingError': inputError['NtcBeta']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} section-input"
                [disabled]="isEnabled" />
                <p class="signifyBookmd section-input-unit mb-0 ml-2">K</p>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (showFieldsAsPerAllOf.includes('DimStart') ) {
      <div [id]="'corridor_DelayTime_container'" class="row slider-container"
        [ngClass]="{'disbaleStyle': isEnabled || isDisabledStartStopDim}">
        <div class="col-1 label signifyBookmd text-mindim dim-margin">Start dim</div>
        @if (!quickConfigvalue) {
          <span class="signifyBookmd text-mindim  sliderMinValue col-1">{{DimStartMin}}</span>
        }
        @if (quickConfigvalue) {
          <div class="col-2">
            <div class="row">
              <div class="col-2"></div>
              <div class="col-2 minValMargin">
                <span class=" signifyBookmd minValue"> min {{ DimStartMin }}</span>
              </div>
              <div class="col-2">
                <span class="signifyBookmd maxValue"> max {{ DimStartMax }}</span>
              </div>
            </div>
          </div>
        }
        @if (!quickConfigvalue) {
          <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': isEnabled || isDisabledStartStopDim}"
            >
            <ngx-slider [options]=DimStartOption [(value)]=DimStartValue (mouseup)="sliderEvent(formControl.value)"
              (userChangeEnd)="DimStartValueChange($event.value)" ngDefaultControl>
            </ngx-slider>
          </div>
        }
        @if (!quickConfigvalue) {
          <span class="signifyBookmd text-mindim  col-1 maxValueCss">{{DimStartMax}}</span>
        }
        <div class="d-flex align-items-center form-group col-3">
          <input type="tel" [(value)]="ngModelval['DimStartValue']"
            (input)="textValChanged($event.target.value, 'DimStart')" id="mtp_StartDim_txtbox"
            (keypress)="numberOnly($event)"
            [ngClass]="{'showingError': inputError['DimStart']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true || isDisabledStartStopDim}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="isEnabled || isDisabledStartStopDim" />
            <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&deg;C</p>
          </div>
        </div>
      }
      @if (showFieldsAsPerAllOf.includes('DimStop') ) {
        <div [id]="'corridor_DelayTime_container'" class="row slider-container"
          [ngClass]="{'disbaleStyle': isEnabled || isDisabledStartStopDim}">
          <div class="col-1 label signifyBookmd text-mindim dim-margin">Stop dim</div>
          @if (!quickConfigvalue) {
            <span class="signifyBookmd text-mindim  sliderMinValue col-1">{{DimStopMin}}</span>
          }
          @if (quickConfigvalue) {
            <div class="col-2">
              <div class="row">
                <div class="col-2"></div>
                <div class="col-2 minValMargin">
                  <span class=" signifyBookmd minValue"> min {{ DimStopMin }}</span>
                </div>
                <div class="col-2">
                  <span class="signifyBookmd maxValue"> max {{ DimStopMax }}</span>
                </div>
              </div>
            </div>
          }
          @if (!quickConfigvalue) {
            <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': isEnabled || isDisabledStartStopDim}"
              >
              <ngx-slider [options]=DimStopOption [(value)]=DimStopValue (mouseup)="sliderEvent(formControl.value)"
                (userChangeEnd)="DimStopValueChange($event.value)" ngDefaultControl>
              </ngx-slider>
            </div>
          }
          @if (!quickConfigvalue) {
            <span class="signifyBookmd text-mindim  col-1 maxValueCss">{{DimStopMax}}</span>
          }
          <div class="d-flex align-items-center form-group col-3">
            <input type="tel" [(value)]="ngModelval['DimStopValue']"
              (input)="textValChanged($event.target.value, 'DimStop')" id="mtp_StopDim_txtbox"
              (keypress)="numberOnly($event)"
              [ngClass]="{'showingError': inputError['DimStop']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true || isDisabledStartStopDim}"
              class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
              [disabled]="isEnabled || isDisabledStartStopDim" />
              <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&deg;C</p>
            </div>
          </div>
        }
        @if (showFieldsAsPerAllOf.includes('DimLevel') ) {
          <div [id]="'corridor_DelayTime_container'" class="row slider-container"
            [ngClass]="{'disbaleStyle': isEnabled}">
            <div class="col-1 label signifyBookmd text-mindim dim-margin">Derating dim level</div>
            @if (!quickConfigvalue) {
              <span class="signifyBookmd text-mindim  sliderMinValue col-1">{{DimLevelMin}}</span>
            }
            @if (quickConfigvalue) {
              <div class="col-2">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-2 minValMargin">
                    <span class=" signifyBookmd minValue"> min {{ DimLevelMin }}</span>
                  </div>
                  <div class="col-2">
                    <span class="signifyBookmd maxValue"> max {{ DimLevelMax }}</span>
                  </div>
                </div>
              </div>
            }
            @if (!quickConfigvalue) {
              <div class="col-6 curvePadding sliderCss" [ngClass]="{'disbaleStyle': isEnabled}">
                <ngx-slider [options]=DimLevelOption [(value)]=DimLevelValue (mouseup)="sliderEvent(formControl.value)"
                  (userChangeEnd)="DimLevelValueChange($event.value)">
                </ngx-slider>
              </div>
            }
            @if (!quickConfigvalue) {
              <span class="signifyBookmd text-mindim  col-1 maxValueCss">{{DimLevelMax}}</span>
            }
            <div class="d-flex align-items-center form-group col-3">
              <input type="tel" [(value)]="ngModelval['DimLevelValue']"
                (input)="textValChanged($event.target.value, 'DimLevel')" id="mtp_DeratingDimLevel_txtbox"
                (keypress)="numberOnly($event)"
                [ngClass]="{'showingError': inputError['DimLevel']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true}"
                class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
                [disabled]="isEnabled" />
                <p class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
              </div>
            </div>
          }
